import { useEffect, useRef, useState } from 'react';
import { ChildStatus } from './types';

export const DEFAULT_TIMEOUT_MS = 8000;

export function useReadinessWithTimeout(args: {
  loading: boolean;
  error?: Error;
  hasData: boolean;
  timeoutMs?: number;
}): ChildStatus {
  const { loading, error, hasData, timeoutMs = DEFAULT_TIMEOUT_MS } = args;

  const [timedOut, setTimedOut] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!loading) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setTimedOut(false);
      return;
    }

    if (timeoutRef.current) return;

    timeoutRef.current = setTimeout(() => {
      setTimedOut(true);
      timeoutRef.current = null;
    }, timeoutMs);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [loading, timeoutMs]);

  if (error) return ChildStatus.Error;
  if (timedOut) return ChildStatus.Timeout;
  if (!loading) return ChildStatus.Ready;
  if (hasData) return ChildStatus.Refetching;
  return ChildStatus.Loading;
}
